import iriitatingImg from "../Assets/Images/irritating.png";
import img2x1 from "../Assets/Images/2x1.png";
import irisImg from "../Assets/Images/iris.png";
import handImg from "../Assets/Images/hand.png";
import handImg2 from "../Assets/Images/hand2.png";

export const projectData = [
  {
    name: "2x-1",
    description:
      "2x-1 is like a hello world of TensorFlow. I built a single-neuron neural network (Simplest NN/Perceptron possible). To learn from the data (By intention I have given data points of equation y=2*x-1) and figure out the equation from the given data. The fun part is all this happens on the user side and in the browser (Model will train on the browser). Visit the website and check the console (F12 > Console).",
    screenshot: img2x1,
    gitLink: "https://github.com/Yoshibansal/BrowserML_2x-1",
    liveLink: "https://deepinfinity-first.netlify.app/",
  },
  {
    name: "Iris",
    description:
      "Using Tensorflow, I designed a Neural Network which is capable of differentiating different classes of Iris. (The data set contains 3 classes of 50 instances each, where each class refers to a type of iris plant.). The data and architecture of the model are defined (remain constant) but training will happen on the browser and on the user side. That means for every user model will be trained separately.\
      \n \
      Visit the website and check the console (F12 > Console).",

    screenshot: irisImg,
    gitLink: "https://github.com/Yoshibansal/BrowserML-CSV-iris",
    liveLink: "https://deepinfinity-second.netlify.app/",
  },
  {
    name: "Hand written digit",
    description: 
    " This model recognizes handwritten digits (0-9) given by the user. This model is built using Tensorflow and in the following steps: \n \
1. Python \n \
    \t    - Data Preparation\n \
    \t    - Data augmentation\n \
    \t    - Build a model (Sequential model)\n \
    \t    - Training and Testing\n \
    \t    - (Once testing is successfully done) Save model\n \
    \t    - Optimize the model (Post-model optimization)\n \
    [To reduce the model size. So that it can be deployed and run on the browser without any hassle]\n \
    \t    - Convert the model into JSON format and save the weights.\n \
2. Design the website (HTML, CSS, JS, JQuery)\n \
3. Deploy the converted model. So that everyone can use it.\n \
\n \
I have done it for handwritten digits but it can be done for any model. Therefore there are an enormous amount of applications of this method.",
    screenshot: handImg,
    gitLink: "https://github.com/Yoshibansal/Handwritten-Digit-Recognition-browser",
    liveLink: "https://deepinfinity-third.netlify.app/",
  },
  {
    name: "Irritating",
    description:
      "This website is built using javascript. ",
    screenshot: iriitatingImg,
    gitLink: "https://github.com/Yoshibansal/irritating",
    liveLink: "https://irritating.netlify.app/",
  },
  {
    name: "MNIST Live",
    description:
      "Training large models live on browser.",
    screenshot: handImg2,
    gitLink: "https://github.com/Yoshibansal/MNIST-Live-Training-onBrowser.git",
    liveLink: "https://deepinfinity-fourth.netlify.app/",
  }
];
